import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode } from "vue";
import { watch, ref } from 'vue';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {
    const route = useRoute();
    const breadcrumbList = ref([]);
    const initBreadcrumbList = () => {
      breadcrumbList.value = route.matched.slice(1);
    };
    watch(route, () => {
      initBreadcrumbList();
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "breadcrumb",
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_TransitionGroup, {
          name: "breadcrumb"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbList.value, item => {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path,
              to: {
                path: item.path
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta?.title), 1)]),
              _: 2
            }, 1032, ["to"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});